import React from 'react';
import { useTranslations } from 'next-intl';
import * as Content from '@components/content';

export default function NoResult({
  locale,
  query,
}: {
  locale: string;
  query: string;
}) {
  const t = useTranslations('Support.faq.no-result');
  return (
    <Content.Wrapper className="flex flex-col items-center gap-6 py-20 pt-0 md:gap-6 md:pt-0">
      <h2 className="text-sh1 font-semibold text-3b-text-secondary md:text-h6">
        {locale === 'ko' ? `${query}${t('title')}` : `${t('title')} ${query}`}
      </h2>
      {/*<a*/}
      {/*  href={`${locale === 'ko' ? '/ko' : ''}/blog`}*/}
      {/*  className="author rounded-[40px] bg-3b-background-medium px-2.5 py-2.5 text-center md:px-8 md:py-3"*/}
      {/*>*/}
      {/*  <span className="text-body2 font-semibold text-3b-text-primary md:text-body1">*/}
      {/*    {t('button')}*/}
      {/*  </span>*/}
      {/*</a>*/}
    </Content.Wrapper>
  );
}
